import { useSyncExternalStore } from 'react';
import { useSearchParams } from 'react-router';

import { getUrlOverlays, subscribeUrlOverlays, type UrlOverlayDefinition } from './url-overlay';
import { useUrlOverlay } from './use-url-overlay.hook';

function UrlOverlaySlot({
  definition,
  value,
}: {
  definition: UrlOverlayDefinition;
  value: string;
}) {
  const { close } = useUrlOverlay(definition.key);
  const Component = definition.component;
  return <Component value={value} close={close} />;
}

/** 주소에 있는 key 의 오버레이를 그린다. app 레이어가 라우터 안에 한 번만 마운트한다. */
export function UrlOverlayHost() {
  const definitions = useSyncExternalStore(subscribeUrlOverlays, getUrlOverlays, getUrlOverlays);
  const [searchParams] = useSearchParams();

  return (
    <>
      {definitions.map((definition) => {
        const value = searchParams.get(definition.key);
        return value === null ? null : (
          <UrlOverlaySlot key={definition.key} definition={definition} value={value} />
        );
      })}
    </>
  );
}
